<template>
  <div class="page-wrapper">
    <!-- ============== PC版 ============== -->
    <div class="pc-version">
      <div
        class="energy-log-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- PC 搜索栏 -->
        <div
          class="search-bar"
          style="
            margin-bottom: 20px;
            display: flex;
            gap: 10px;
            align-items: center;
            flex-wrap: wrap;
          "
        >
          <div class="search-collapse-btn" @click="toggleSearch">
            <i
              class="el-icon-arrow-down"
              :class="{ 'el-icon-arrow-up': !searchCollapsed }"
            ></i>
            {{ searchCollapsed ? "展开搜索" : "收起搜索" }}
          </div>
          <div
            :style="{
              display: searchCollapsed ? 'none' : 'flex',
              gap: '10px',
              alignItems: 'center',
            }"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              style="width: 160px"
              clearable
            ></el-input>
          </div>
          <div style="display: flex; gap: 10px; margin-left: 10px">
            <el-button type="primary" @click="getList">搜索</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </div>
        </div>

        <el-table
        height="900"
          :data="tableData"
          border
          stripe
          style="width: 100%"
          @row-click="handleRowClick"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="用户ID" prop="user_id" width="120" align="center" />
          <!-- 接口无昵称字段，已移除 -->
          <el-table-column label="能量变动" prop="amount" width="120" align="center" />
          <el-table-column label="当前能量" prop="after_amount" width="120" align="center" />
          <el-table-column label="变动类型" prop="type_name" min-width="120" align="center" />
          <el-table-column label="备注" prop="remark" min-width="180" show-overflow-tooltip />
          <el-table-column label="创建时间" prop="created_at" width="180" align="center" />
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC详情弹窗 -->
        <el-dialog
          title="能量日志详情"
          :visible.sync="detailVisible"
          width="600px"
          append-to-body
        >
          <el-form :model="detailForm" label-width="120px" size="small">
            <el-form-item label="ID"><span>{{ detailForm.id }}</span></el-form-item>
            <el-form-item label="用户ID"><span>{{ detailForm.user_id }}</span></el-form-item>
            <el-form-item label="能量变动"><span>{{ detailForm.amount }}</span></el-form-item>
            <el-form-item label="当前能量"><span>{{ detailForm.after_amount }}</span></el-form-item>
            <el-form-item label="变动类型"><span>{{ detailForm.type_name }}</span></el-form-item>
            <el-form-item label="备注信息"><span>{{ detailForm.remark || '-' }}</span></el-form-item>
            <el-form-item label="创建时间"><span>{{ detailForm.created_at }}</span></el-form-item>
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ============== 移动端 ============== -->
    <div class="mobile-version">
      <div
        class="mobile-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <div class="mobile-search">
          <div class="mobile-search-collapse" @click="toggleSearch">
            {{ searchCollapsed ? "展开搜索条件 ▼" : "收起搜索条件 ▲" }}
          </div>
          <div
            v-if="!searchCollapsed"
            style="display: flex; flex-direction: column; gap: 8px"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              clearable
              size="medium"
            ></el-input>
          </div>
          <div style="display: flex; gap: 8px; margin-top: 10px">
            <el-button
              type="primary"
              plain
              round
              style="flex: 1"
              @click="getList"
              >搜索</el-button
            >
            <el-button plain round style="flex: 1" @click="resetSearch"
              >重置</el-button
            >
          </div>
        </div>

        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="handleRowClickMobile(item)"
          >
            <div class="card-top">
              <div class="label">{{ item.type_name }}</div>
            </div>

            <div class="card-body">
              <div><span>用户ID：</span>{{ item.user_id }}</div>
              <div><span>能量变动：</span>{{ item.amount }}</div>
              <div><span>当前能量：</span>{{ item.after_amount }}</div>
              <div><span>备注：</span>{{ item.remark || '-' }}</div>
              <div><span>时间：</span>{{ item.created_at }}</div>
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="prev, pager, next, total"
            :total="total"
            pager-count="2"
            small
          />
        </div>

        <!-- 移动端详情弹窗 -->
        <el-dialog
          title="能量日志详情"
          :visible.sync="detailVisibleMobile"
          width="90%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form :model="detailForm" label-width="100px" size="small">
            <el-form-item label="ID"><span>{{ detailForm.id }}</span></el-form-item>
            <el-form-item label="用户ID"><span>{{ detailForm.user_id }}</span></el-form-item>
            <el-form-item label="能量变动"><span>{{ detailForm.amount }}</span></el-form-item>
            <el-form-item label="当前能量"><span>{{ detailForm.after_amount }}</span></el-form-item>
            <el-form-item label="类型"><span>{{ detailForm.type_name }}</span></el-form-item>
            <el-form-item label="备注"><span>{{ detailForm.remark || '-' }}</span></el-form-item>
            <el-form-item label="时间"><span>{{ detailForm.created_at }}</span></el-form-item>
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisibleMobile = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";

export default {
  name: "UserEnergyLog",
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      // 搜索参数
      searchParams: {
        page: 1,
        page_size: 10,
        user_id: "",
      },
      // 详情弹窗
      detailVisible: false,
      detailVisibleMobile: false,
      detailForm: {},
      // 搜索折叠
      searchCollapsed: true,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取能量日志列表
    async getList() {
      this.loading = true;
      try {
        const res = await api.users.energyLog({
          params: this.searchParams,
        });
        if (res.data.code == "1000") {
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
        }
      } finally {
        this.loading = false;
      }
    },

    // PC行点击查看详情
    handleRowClick(row) {
      this.detailForm = { ...row };
      this.detailVisible = true;
    },
    // 移动端卡片点击查看详情
    handleRowClickMobile(row) {
      this.detailForm = { ...row };
      this.detailVisibleMobile = true;
    },

    // 重置搜索
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        user_id: "",
      };
      this.getList();
    },

    // 每页条数改变
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    // 当前页改变
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
    // 展开/收起搜索
    toggleSearch() {
      this.searchCollapsed = !this.searchCollapsed;
    },
  },
};
</script>

<style scoped>
.energy-log-container {
  padding: 20px;
}
.mobile-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search {
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 10px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-top {
  margin-bottom: 10px;
}
.card-top .label {
  font-size: 15px;
  font-weight: 500;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.8;
}
.card-body span {
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/pages/user/energyLog.vue